import { UniversalCrud, UniversalDetail } from "@stdoutsrl/design-kit";
import { ExampleMonouseComponent } from "../tables-custom-actions/example-table-component.component";
import { api, environment } from "../../environments/environment";

export const customers: UniversalCrud = {
  showSideNav: true,
  route: 'customers',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  endpoint: "/users",
  // details: {
  //   route: "routes.employee.path",
  // },
  breadcrumb: [{ title: "Clienti", route: "/clienti" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    // {
    //   element: "birthDate",
    //   table: true,
    //   editable: true,
    //   creation: true,
    //   filterable: true,
    //   operator: true,
    //   obligatory: false,
    //   type: "date",
    // },
    // {
    //   element: "time",
    //   table: true,
    //   editable: true,
    //   creation: true,
    //   filterable: true,
    //   operator: true,
    //   obligatory: false,
    //   type: "time",
    // },
    // {
    //   element: "dateTime",
    //   table: true,
    //   editable: false,
    //   creation: true,
    //   filterable: true,
    //   operator: true,
    //   obligatory: false,
    //   type: "datetime",
    // },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text",
    },
    // {
    //   element: "cell",
    //   table: true,
    //   editable: true,
    //   creation: true,
    //   filterable: true,
    //   operator: true,
    //   obligatory: true,
    //   type: "text",
    // },
    // {
    //   element: "note",
    //   table: true,
    //   editable: true,
    //   creation: true,
    //   filterable: true,
    //   operator: true,
    //   obligatory: true,
    //   type: "text",
    // },
  ],
};

export const locations: UniversalCrud = {
  showSideNav: true,
  route: 'locations',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true, endpoint: "/location",

  breadcrumb: [{ title: "Località", route: "/manager/localita" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
          element: "available",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: true,
          selectArray: [
            { value: false, label: "No" },
            { value: true, label: "Si" },
          ],
        },
  ],

};

export const bundles: UniversalCrud = {
  showSideNav: true,
  route: 'bundles',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true, endpoint: "/subscription",
  breadcrumb: [{ title: "Pacchetti", route: "/manager/pacchetti" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "number",
    },
    {
          element: "season",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: true,
          prefixTranslateValue:"seasons.",
          selectArray: [
            { value: "Alta stagione", label: "Alta stagione" },
            { value: "Media stagione", label: "Media stagione" },
            { value: "Bassa stagione", label: "Bassa stagione" },
          ],
        },
        {
          element: "price",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "number",
        },
    {
          element: "available",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: true,
          selectArray: [
            { value: false, label: "No" },
            { value: true, label: "Si" },
          ],
        },
  ],

};

export const rates: UniversalCrud = {
  showSideNav: true,
  route: 'rates',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true, endpoint: "/tariff",

  breadcrumb: [{ title: "Tariffario", route: "/manager/tariffario" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
          element: "season",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: false,
          selectArray: [
            { value: "Alta stagione", label: "Alta stagione" },
            { value: "Media stagione", label: "Media stagione" },
            { value: "Bassa stagione", label: "Bassa stagione" },
          ],
        },
        {
          element: "price",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "number",
        },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
          element: "available",
          table: false,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: true,
          selectArray: [
            { value: false, label: "No" },
            { value: true, label: "Si" },
          ],
        },
  ],

};

export const boatTypes: UniversalCrud = {
  showSideNav: true,
  route: 'boatTypes',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true, 
  endpoint: "/type",
  breadcrumb: [{ title: "Tipo Barche", route: "/manager/tipo-barche" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
  ],

};

export const floatingBoats: UniversalCrud = {
  showSideNav: true,
  route: 'floatingBoats',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true, 
  endpoint: "/boat",
  breadcrumb: [{ title: "Gommoni", route: "/manager/gommoni" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
  ],

};


//only for example



export const platforms: UniversalCrud = {
  showSideNav: true,
  route: 'platforms',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false, endpoint: "/platforms",

  breadcrumb: [{ title: "platforms", route: "/platforms" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text",
    },
    {
      element: "slug",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
  ],

};

export const events: UniversalCrud = {
  showSideNav: true,
  route: 'events',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false, endpoint: "/events",
  details: {
    route: "event",
  },
  breadcrumb: [{ title: "events", route: "/events" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: false,
      obligatory: false,
      type: "text",
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "partecipants",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: false,
      obligatory: true,
      type: "number",
    },
  ],
};
export const event: UniversalDetail = {
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  currentBreadcrumb: 1,
  endpoint: "event",
  breadcrumb: [
    { title: "events", route: "/events" },
    { title: "event", route: "/event" },
  ],
  details: events.table,
  tables: [
    {
      details: {
        route: "subnote",
      },
      canAddElement: true,
      canDeleteElement: true,
      canEditElement: true,
      name: "notes",
      active: false,
      endpoint: "notes",
      table: [
        {
          element: "id",
          table: true,
          editable: false,
          creation: false,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "name",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "note",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
      ],
    },
    {
      canAddElement: false,
      canDeleteElement: false,
      canEditElement: false,
      name: "locations",
      active: true,
      endpoint: "locations",
      table: [
        {
          element: "id",
          table: true,
          editable: false,
          creation: false,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "name",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "cap",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "available",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: true,
          obligatory: false,
          type: "select",
          translateValue: true,
          selectArray: [
            { value: false, label: "No" },
            { value: true, label: "Si" },
          ],
        },
        {
          element: "state",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
        {
          element: "country",
          table: true,
          editable: true,
          creation: true,
          filterable: true,
          operator: false,
          obligatory: true,
          type: "text",
        },
      ],
    },
  ],

};

export const employees: UniversalCrud = {
  showSideNav: true,
  route: 'employees',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  endpoint: "/employees",
  details: {
    route: "routes.employee.path",
  },
  breadcrumb: [{ title: "employees", route: "/employees" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "text",
    },
    {
      element: "categories",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "multiselect",
      multipleSelectArrayValue: true,
      selectArray: [{ label: 'br1', value: 'br1' }, { label: 'br2', value: 'br2' }],
    },
    {
      element: "roles",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: 'role.',
      selectArray: [{ label: 'Admin', value: 1 }, { label: 'Manager', value: 2 }, { label: 'Dipendente', value: 3 }],
    },
    {
      element: "paycheck",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "birthDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "date",
    },
    {
      element: "time",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "time",
    },
    {
      element: "dateTime",
      table: true,
      editable: false,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "datetime",
    },
    {
      element: "fisrtName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "cell",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "note",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
  ],
};

export const employee: UniversalDetail = {
  route: 'employee',
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,
  breadcrumb: [
    { title: "employees", route: "/employees" },
    { title: "Employee", route: "/employee/:id" },
  ],
  customActionsTop: [
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top 2",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Top3 ",
      translateLabel: false,
    },
  ],
  customActionsCard: [
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card 2",
      translateLabel: false,
    },
    {
      component: ExampleMonouseComponent,
      label: "Example Custom Action Card ",
      translateLabel: false,
    },
  ],
  currentBreadcrumb: 1,
  endpoint: "/employees",
  details: employees.table,
};

export const employeesSingle: UniversalCrud = {
  showSideNav: true,
  route: 'employeesSingle',
  usePageCreation: {
    route: 'addSingleEmployee'
  },
  environment: environment,
  api: api,
  step5Minutes: false,
  showClock: true,
  use24h: true,

  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
  endpoint: "/employees",
  details: {
    route: "routes.employee.path",
  },
  breadcrumb: [{ title: "employeesSingle", route: "/employeesSingle" }],
  table: [
    {
      element: "id",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "text",
    },
    {
      element: "categories",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "multiselect",
      multipleSelectArrayValue: true,
      selectArray: [{ label: 'br1', value: 'br1' }, { label: 'br2', value: 'br2' }],
    },
    {
      element: "roles",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue: true,
      prefixTranslateValue: 'role.',
      selectArray: [{ label: 'Admin', value: 1 }, { label: 'Manager', value: 2 }, { label: 'Dipendente', value: 3 }],
    },
    {
      element: "paycheck",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number",
    },
    {
      element: "birthDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "date",
    },
    {
      element: "time",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "time",
    },
    {
      element: "dateTime",
      table: true,
      editable: false,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: false,
      type: "datetime",
    },
    {
      element: "fisrtName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "cell",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
    {
      element: "note",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,

      obligatory: true,
      type: "text",
    },
  ],

};